'use strict';
import React, { Component } from 'react';

class NumeroCuotaColumn extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { CuotaNumero, Cierre } = this.props;

        return <td className={"bordeado th-cierres" + (Cierre == 6 ? " col-grey" : "")}>
            <label className="label-primary lbl-cierres-cuota">{CuotaNumero != "-" ? CuotaNumero : "-" }</label>
        </td>

    }

}
export default NumeroCuotaColumn;